import styled from 'styled-components';
import { flexbox,
  alignItems,
  flexDirection,
  justifyContent } from '../../styles/helpers/flexbox';
import ThemeHelper from '../../themes/theme-helper';

const Wrapper = styled.span((props) => {
  const { colours } = ThemeHelper.getTheme(props);

  return `
    ${flexbox()};
    ${flexDirection('column')};

    border-right: 1px solid ${colours.grey[500]};
    box-sizing: border-box;
    font-size: 12px;
    position: relative;
    height: fit-content;
`;
});

const FixedWrapper = styled.div((props) => {
  const { colours } = ThemeHelper.getTheme(props);

  return `
  position: sticky;
  top: 1px;
  z-index: 3;
  border-top: 1px solid ${colours.grey[400]};
`;
});

const StandardWrapper = styled.div((props) => {
  const LEARNING_JOURNEY_WIDTH = 54;
  const { lj } = props;
  const { colours } = ThemeHelper.getTheme(props);

  return `
    ${flexbox()};
    ${justifyContent('space-between')};

    width: ${lj * LEARNING_JOURNEY_WIDTH}px;
    min-height: 40px;
    height: 40px;
    background-color: #c3d5e1
    border: ${lj > 0 ? `1px solid ${colours.grey[400]}` : 'none'};
    border-right: ${lj > 0 ? `1px solid ${colours.grey[500]}` : 'none'};
    border-top: none;
    box-sizing: border-box;
    font-size: 12px;
    overflow: hidden;
    cursor: pointer;
`;
});

const LearningJourneyWrapper = styled.span((props) => {
  const { colours } = ThemeHelper.getTheme(props);

  return `
    ${flexbox()};

    height: 150px;
    font-size: 12px;
    background-color: #eaf9f9;
    color: ${colours.grey[800]};
`;
});

const CollapsedWrapper = styled.span((props) => {
  const { colours } = ThemeHelper.getTheme(props);

  return `
    ${flexbox()};
    ${flexDirection('column')};

    width: 54px;
    border-right: 1px solid ${colours.grey[500]};
`;
});

const Content = styled.span((props) => {
  const { colours } = ThemeHelper.getTheme(props);

  return `
    ${flexbox()};
    ${flexDirection('column')};

    width: calc(100% - 23px);
    color: ${colours.grey[800]};
`;
});

const TopicName = styled.div((props) => {
  const { palette } = ThemeHelper.getTheme(props);

  return `
    text-overflow: ellipsis;
    overflow: hidden;
    white-space: nowrap;
    color: ${palette.primary.dark};
`;
});

const ExternalKey = styled(TopicName)`
    text-transform: uppercase;
`;

const Icon = styled.div`
    ${flexbox()};
    ${alignItems('center')};

    cursor: pointer;
    height: 40px;

    [class^="svgIconComponent"] {
      width: 15px !important;
    }

    &:hover {
      path {
        fill: #3b4e5e !important;
      }
    }

    &:active {
      path {
        fill: #000 !important;
      }
    }
`;

const Info = styled.div`
  ${flexbox()};
  ${justifyContent('space-between')};

  width: calc(100% - 15px);
  padding: 1px;
`;

export {
  Wrapper,
  ExternalKey,
  TopicName,
  Icon,
  Content,
  StandardWrapper,
  LearningJourneyWrapper,
  Info,
  FixedWrapper,
  CollapsedWrapper
};
